var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"component-preview"},[_c('h2',{staticClass:"first"},[_c('i',{staticClass:"af-icons af-icons-preview"}),_vm._v(" "+_vm._s(_vm.heading))]),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }